import React, {useRef, useEffect} from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import illustration from '../images/spotIllustration.svg'
import WidthContainer from '../../../components/WidthContainer'

const phoneBreakpoint = '@media only screen and (max-width: 700px)'

const RootContainer = styled(WidthContainer)`
`

const TextRow = styled.div`
	position: relative;
	display: flex;
	
	${phoneBreakpoint} {
		flex-direction: column-reverse;
		align-items: center;
	}
`

const Title = styled.h2`
	font-size: ${props => props.theme.fontSizes.big$0};
`

const Text = styled.div`
`

const TextContainer = styled.div`
	max-width: 24rem;
`

const Illustration = styled.img`
	margin-top: -5rem;
	margin-left: 2rem;
`
Illustration.defaultProps = {
	alt: '',
	src: illustration,
}

const IframeContainer = styled.div`
	margin-top: 2rem;
	text-align: center;
	button {
		font-size: ${props => props.theme.fontSizes.smallest};
		font-weight: ${props => props.theme.fontWeights.regular};
		color: white;
		text-align: center;
		background: ${props => props.theme.colors.main};
		padding: .5rem 1.2rem;
		border: 1px solid ${props => props.theme.colors.main};
		border-radius: 0 9rem 9rem 9rem;
		transition: ${props => props.theme.transitions.smallElements} ease;
		cursor: pointer;
		white-space: nowrap;
		display: inline-block;
		min-width: 9rem;
		
		&:hover {
			background: ${props => props.theme.colors.mainDarker};	
			border-color: ${props => props.theme.colors.mainDarker};	
			text-decoration: none;
		}
	}
`

function SpotSection({className, data}) {
	const iframeContainer = useRef(null)
	useEffect(() => {

		const onScriptLoaded = () => {
			window.EBWidgets.createWidget({
				widgetType: 'checkout',
				eventId: data.eventId,
				iframeContainerId: 'eventbrite-widget-container',
				iframeContainerHeight: 425,
				onOrderComplete: exampleCallback,
			})
		}

		const exampleCallback = () => {
			console.log('Order complete!')
		}

		const script = document.createElement('script')
		script.src = 'https://www.eventbrite.com/static/widgets/eb_widgets.js'
		script.onload = function () {
			onScriptLoaded()
		}
		iframeContainer.current.appendChild(script)

	}, [])

	return <RootContainer className={className}>
		<TextRow>
			<TextContainer>
				<Title>{data.title}</Title>
				<Text>{data.text}</Text>
			</TextContainer>
			<Illustration/>
		</TextRow>
		<IframeContainer ref={iframeContainer}>
			<div id="eventbrite-widget-container"/>
		</IframeContainer>
	</RootContainer>
}

SpotSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		eventId: PropTypes.string.isRequired,
	}).isRequired,
}

SpotSection.defaultProps = {
	className: '',
}

export default SpotSection
